/**
 * clerkConfig.js — Configuración del cliente Clerk para el frontend.
 *
 * Feature flag: VITE_USE_CLERK ('true' | 'false')
 *   - false (default): la app usa el auth legacy (Redux + JWT en localStorage).
 *   - true: la app envuelve el árbol con <ClerkProvider> y expone rutas /sign-in y /sign-up.
 *
 * Variables de entorno:
 *   VITE_CLERK_PUBLISHABLE_KEY — pk_test_... obtenido del dashboard de Clerk.
 *   VITE_USE_CLERK             — activa el provider y rutas.
 */
export const isClerkEnabled = () =>
  import.meta.env.VITE_USE_CLERK === 'true' &&
  Boolean(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY)

export const clerkPublishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY || ''

/**
 * Apariencia básica alineada con el tema de la app (rojo bomberil).
 * Ver https://clerk.com/docs/components/customization/overview
 */
export const clerkAppearance = {
  variables: {
    colorPrimary: '#c62828',
    colorText: '#1f2937',
    borderRadius: '8px',
  },
  elements: {
    formButtonPrimary:
      'bg-red-700 hover:bg-red-800 text-white normal-case rounded-md',
    card: 'shadow-lg',
  },
}
